import * as RadixSwitch from "@radix-ui/react-switch";
import { cn } from "@/lib/utils";

export function Switch({
  checked,
  onCheckedChange,
  disabled,
  className,
}: {
  checked: boolean;
  onCheckedChange: (v: boolean) => void;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <RadixSwitch.Root
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      className={cn(
        "relative inline-flex h-5 w-9 cursor-pointer items-center rounded-full transition-colors",
        "bg-[var(--color-border)] data-[state=checked]:bg-[var(--color-accent-bg)]",
        "focus:outline-none focus:ring-1 focus:ring-[var(--color-accent)]",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
    >
      <RadixSwitch.Thumb className="size-3.5 rounded-full bg-white shadow translate-x-0.5 transition-transform data-[state=checked]:translate-x-[18px]" />
    </RadixSwitch.Root>
  );
}
